import Theme from '../../styles/Theme/Theme';

type TReturn = {
    iconColor: keyof typeof Theme.color;
    name: string;
} | null;

export const statusMapping = (level: number): TReturn => {
    if (level === 1) return { iconColor: 'teal-1', name: 'Aberto' };
    if (level === 15) return { iconColor: 'teal-3', name: 'Aguarda análise' };
    if (level === 2) return { iconColor: 'teal-5', name: 'Resolução em curso' };
    if (level === 3) return { iconColor: 'warning-4', name: 'Em pausa' }; // 
    if (level === 14) return { iconColor: 'teal-6', name: 'Transferido' }; // 
    if (level === 6) return { iconColor: 'success-4', name: 'Resolvido' };
    if (level === 27) return { iconColor: 'coolgray-4', name: 'Fechado' };
    if (level === 8) return { iconColor: 'error-4', name: 'Cancelado' }; //

    return null;
};
